import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUsageType implements BaseEnumType {
  private static allValues: EnumUsageType[] = []; // make sure this is top-most
  
  public static none = new EnumUsageType(0, "None", "enum_usage_type_none");
  public static sms = new EnumUsageType(1, "Sms", "enum_usage_type_sms");
  public static addressAutocomplete = new EnumUsageType(2, "AddressAutocomplete", "enum_usage_type_address_autocomplete");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUsageType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUsageType.none; }
  public isSms() { return this === EnumUsageType.sms; }
  public isAddressAutocomplete() { return this === EnumUsageType.addressAutocomplete; }

  public static getValues(): readonly EnumUsageType[] {
    return EnumUsageType.allValues;
  }

  public static getValuesExcept0(): readonly EnumUsageType[] {
    return EnumUsageType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUsageType {
    const found = EnumUsageType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUsageType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUsageType): EnumUsageType {
    const found = name ? EnumUsageType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUsageType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUsageType>): boolean {
    return this.key === other?.key;
  }
}